import React from 'react';
import Reveal from './Reveal';
import TiltCard from './TiltCard';
import { FireIcon } from './icons';
import mascot from '../../public/theone.webp';
import '../styles/about.css';

const About = () => (
  <section className="section about" id="about">
    <Reveal className="about-head">
      <span className="eyebrow">why $KEK</span>
      <h2 className="section-title">not just another <span className="accent">frog coin</span></h2>
      <p className="section-lead">
        Most memecoins inflate, dump and vanish. $KEK is a community meme token on WAX
        with transparent on-chain transfer mechanics. It is not an investment product
        and has no intrinsic value or expectation of financial return.
      </p>
    </Reveal>

    <div className="about-bento">
      <TiltCard className="bento bento--defl">
        <div className="bento-icon"><FireIcon /></div>
        <h3>Deflationary by design</h3>
        <p>
          Token flows include a transfer fee split, but this is an entertainment-only token
          and past mechanics do not guarantee future behavior. Only participate if you
          accept the risk of loss.
        </p>
        <div className="bento-mech">
          <span className="mech-pill mech-burn">3% burn</span>
          <span className="mech-pill mech-stake">2% stakers</span>
          <span className="mech-pill">= 5% fee</span>
        </div>
      </TiltCard>

      <TiltCard className="bento bento--mascot" max={5}>
        <img src={mascot} alt="Wax Pepe mascot" loading="lazy" />
        <div className="bento-mascot-cap">
          <span className="neon-text">$KEK</span>
          <span>pure meme, on-chain</span>
        </div>
      </TiltCard>

      <TiltCard className="bento bento--stake">
        <h3>Staking &amp; P2E</h3>
        <p>
          $KEK is a meme token for entertainment only. Community events, third-party games,
          and token features are entirely at your own risk and carry no expected value.
        </p>
      </TiltCard>

      <TiltCard className="bento bento--comm">
        <h3>Community-owned</h3>
        <p>
          Community controls are limited, the token is provided for entertainment only,
          and there is no guaranteed development program or issuer team. Use at your own
          risk and comply with your local laws.
        </p>
      </TiltCard>
    </div>
  </section>
);

export default About;
